import { gsap } from 'gsap';
import { WbScroller } from '../../webit_modules/wb-scroller/src';

export class WbAnimations {
  constructor() {
    const _this = this;

    this.intervals = [];
    this.addScroller();
    this.removeInitialLoading();
    this.init();

    document.addEventListener('_before_page_loaded', _this.init.bind(_this));
  }

  init() {
    return new Promise((resolve, reject) => {
      this.intervals?.forEach(interval => clearInterval(interval));
      this.addAnims();
      resolve();
    });
  }

  addScroller() {
    this.scroller = window.WbScroller = new WbScroller();
    this.scroller.init();
  }

  wait(duration = 25) {
    return new Promise((resolve, reject) => {
      setTimeout(resolve, duration);
    });
  }

  randomNumber(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  removeInitialLoading() {
    const overlay = document.querySelector('.wb-load-overlay--initial');

    gsap.to(overlay, {
      opacity: 0,
      duration: 0.5,
      delay: 0.35,
      onComplete: () => {
        overlay._remove();
      },
    });
  }

  addAnims() {
    // this.addHomeAnims();
    this.addCountUpAnims();
  }

  addHomeAnims() {
    if (document.querySelector('.home')) {
      this.archeoBoxes = document.querySelectorAll('.wb-banner wb-archeomusee__box--rdm');
      this.animateArcheoBoxes();

      const archeoInterval = setInterval(this.animateArcheoBoxes.bind(this), 1500);
      this.intervals.push(archeoInterval);
    }
  }

  animateArcheoBoxes() {
    const archeoBanner = document.querySelectorAll('.wb-archeomusee--banner');

    if (archeoBanner) {
      if (this.archeoBoxes.length === 0) {
        this.archeoBoxes = document.querySelectorAll('.wb-archeomusee--banner .wb-archeomusee__box--rdm');
      }

      const rdmEle = this.archeoBoxes[this.randomNumber(0, this.archeoBoxes.length - 1)];
      this.archeoBoxes = [...this.archeoBoxes].filter(box => box !== rdmEle);

      gsap.set(rdmEle, { opacity: 1 });

      this.wait(1500).then(() => {
        gsap.set(rdmEle, { opacity: 0 });
      });
    }
  }

  addCountUpAnims() {
    const page = document.querySelector('body');

    page?.querySelectorAll('.wb-number-text__number--animate')?.forEach(count => {
      this.scroller.addAnim({
        element: count,
        trigger: '[data-scroll-section]',
        timeline: [
          {
            to: {
              innerText: count.dataset.number,
              stagger: 0.1,
              snap: {
                innerText: 1,
              },
              duration: 3,
            },
          },
        ],
      });
    });
  }
}
